<app-header></app-header>

<div class="email-container">
  <div class="email-content">
    <!-- Section de statut -->
    <div class="status-section">
      <div class="status-indicator">
        <i class="bi bi-check-circle-fill"></i>
        <span>Conversion réussie !</span>
      </div>
      <div class="filename">{{ filename }}</div>
    </div>

    <!-- Question principale -->
    <h2 class="main-question">Quelle est votre adresse électronique ?</h2>
    <p class="instruction-text">Saisissez votre adresse e-mail pour recevoir le fichier Word</p>

    <!-- Formulaire -->
    <div class="form-card">
      <form (ngSubmit)="onSubmit()" #emailForm="ngForm">
        <div class="form-group">
          <input 
            type="email" 
            class="form-control" 
            placeholder="Votre e-mail"
            [(ngModel)]="email"
            name="email"
            required
            email
            #emailInput="ngModel">
        </div>

        <p class="privacy-statement">
          Nous respectons votre vie privée et nous ne vendrons ni ne partagerons votre adresse e-mail.
        </p>

        <button type="submit" class="btn btn-primary continue-btn" [disabled]="!emailForm.valid || isLoading">
          <span *ngIf="!isLoading">Continuer</span>
          <span *ngIf="isLoading" class="spinner-container">
            <i class="bi bi-arrow-clockwise spin"></i>
            Chargement...
          </span>
        </button>

        <div class="legal-links">
          En poursuivant, vous acceptez nos <br>
          <span>
            <a href="#" class="legal-link">Conditions d'utilisation</a> et
            <a href="#" class="legal-link">Politique de confidentialité</a>
          </span>
        </div>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>
